import { useEffect, useState } from 'react';
import {
  getServiceProviders,
  getServiceProvidersFilteredByPropertyId,
} from 'src/services/client';
import { IServiceProvidersListParams } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import { CanonicalContact, normalizeContacts } from '../helpers/contactShape';

interface UseContactPickerDataArgs {
  serviceRequest: any;
  from: any;
}

export interface ContactPickerData {
  propertyContacts: CanonicalContact[];
  allContacts: CanonicalContact[];
  isLoading: boolean;
}

export const useContactPickerData = ({
  serviceRequest,
  from,
}: UseContactPickerDataArgs): ContactPickerData => {
  const [propertyContacts, setPropertyContacts] = useState<CanonicalContact[]>(
    []
  );
  const [allContacts, setAllContacts] = useState<CanonicalContact[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const buildListParams = (): IServiceProvidersListParams => ({
    Name: serviceRequest.serviceType
      ? serviceRequest.serviceType
      : serviceRequest.issueType?.name,
    id: serviceRequest.propertyId,
    Type: from === 'dashboard' ? 'Bulk' : null,
  });

  const warnOnUnrecognizedRoles = (contacts: CanonicalContact[]): void => {
    const seen = new Set<string>();

    for (const contact of contacts) {
      if (contact.role === 'Unrecognized' && !seen.has(contact.originalRole)) {
        seen.add(contact.originalRole);

        console.warn(
          `ContactPicker: unrecognized contact role "${contact.originalRole}" (userId ${contact.id})`
        );
      }
    }
  };

  const loadContacts = async () => {
    setIsLoading(true);

    const params: IServiceProvidersListParams = buildListParams();

    const [allRaw, propertyResponse] = await Promise.all([
      getServiceProviders(params),
      getServiceProvidersFilteredByPropertyId(serviceRequest.propertyId),
    ]);

    const all: CanonicalContact[] = normalizeContacts(allRaw);
    const property: CanonicalContact[] = normalizeContacts(propertyResponse.data);

    warnOnUnrecognizedRoles(all);
    warnOnUnrecognizedRoles(property);

    setAllContacts(all);
    setPropertyContacts(property);
    setIsLoading(false);
  };

  useEffect(() => {
    loadContacts();
  }, []);

  return { propertyContacts, allContacts, isLoading };
};
